var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0C41.3261 0 42.5979 0.526784 43.5355 1.46447C44.4732 2.40215 45 3.67392 45 5V40C45 41.3261 44.4732 42.5979 43.5355 43.5355C42.5979 44.4732 41.3261 45 40 45H5C3.67392 45 2.40215 44.4732 1.46447 43.5355C0.526784 42.5979 0 41.3261 0 40V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0H40ZM38.75 38.75V25.5C38.75 23.3385 37.8913 21.2655 36.3629 19.7371C34.8345 18.2087 32.7615 17.35 30.6 17.35C28.475 17.35 26 18.65 24.8 20.6V17.825H17.825V38.75H24.8V26.425C24.8 24.5 26.35 22.925 28.275 22.925C29.2033 22.925 30.0935 23.2937 30.7499 23.9501C31.4063 24.6065 31.775 25.4967 31.775 26.425V38.75H38.75ZM9.7 13.9C10.8139 13.9 11.8822 13.4575 12.6698 12.6698C13.4575 11.8822 13.9 10.8139 13.9 9.7C13.9 7.375 12.025 5.475 9.7 5.475C8.57946 5.475 7.50482 5.92013 6.71247 6.71247C5.92013 7.50482 5.475 8.57946 5.475 9.7C5.475 12.025 7.375 13.9 9.7 13.9ZM13.175 38.75V17.825H6.25V38.75H13.175Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c6cefd58640ace9ada363fdb71e29968.svg";
export { ForwardRef as ReactComponent };